import { render, staticRenderFns } from "./fusionAdmin.vue?vue&type=template&id=271f2bb7"
import script from "./fusionAdmin.vue?vue&type=script&lang=js"
export * from "./fusionAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports